import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  blik_code: 'Kod BLIK',
  blik_invoice__title: 'Zapłać kodem BLIK',
  blik_invoice__subtitle: 'Wpisz 6-cyfrowy kod wygenerowany w aplikacji bankowej.',
  blik_invoice__code_hint: 'Kod jest ważny przez 2 minuty.',
  blik_invoice__pay_button: 'Zapłać {amount} {currency}',
  blik_invoice__help_link: 'Skąd wziąć kod BLIK?',
  blik_invoice__help_text: 'Kod BLIK można wygenerować w aplikacji mobilnej banku:',
  blik_invoice__help_step_1: 'Otwórz aplikację mobilną swojego banku.',
  blik_invoice__help_step_2: 'Wybierz BLIK i wygeneruj 6-cyfrowy kod.',
  blik_invoice__help_step_3: 'Wpisz kod powyżej i kliknij „Zapłać”.',
  blik_invoice__requisites_title: 'Dane do przelewu',
  blik_invoice__waiting_title: 'Potwierdź płatność w aplikacji bankowej',
  blik_invoice__waiting_text:
    'Otwórz aplikację bankową i zaakceptuj płatność. Nie zamykaj tej strony.',
  blik_invoice__waiting_cancel: 'Anuluj płatność',
  blik_invoice__status_declined_title: 'Płatność odrzucona',
  blik_invoice__status_declined_text: 'Bank nie zatwierdził płatności.',
  blik_invoice__status_declined_hint:
    'Sprawdź saldo lub spróbuj ponownie, używając nowego kodu BLIK.',
  blik_invoice__status_back: 'Wróć do sklepu',
  blik_invoice__status_success_title: 'Płatność zakończona',
  blik_invoice__status_success_text: 'Płatność została zatwierdzona.',
  blik_invoice__status_expired_title: 'Płatność wygasła',
  blik_invoice__status_expired_text: 'Czas na opłacenie minął.',
  blik_invoice__confirmation_invalid:
    'Nie udało się wczytać danych potwierdzenia. Wróć do sklepu i spróbuj ponownie.',
};
